import * as actionTypes from "constants/actionTypes";
import { NAV_MODES } from "constants/navModes";

const initialState = {
  navMode: NAV_MODES.NORMAL
};

export default function navigation(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_OVERLAY_NAV_MODE: {
      const { navMode } = action.payload;
      return {
        ...state,
        navMode
      };
    }
    case actionTypes.HIDE_OVERLAY_NAV:
      return {
        ...state,
        navMode: NAV_MODES.OVERLAY_CLOSED
      };
    case actionTypes.SHOW_OVERLAY_NAV:
      return {
        ...state,
        navMode: NAV_MODES.OVERLAY_OPEN
      };
    default:
      return state;
  }
}

export const selectNavMode = state => state.navigation.navMode;
